<template>
  <div class="query-bar">
    <template>
      <span
        v-for="breakpoint of Object.keys(breakpoints)"
        :key="breakpoint"
        :class="{ 'query-bar__active': breakpoint[breakpoint] }">{{ breakpoint }}: {{ breakpoints[breakpoint] }}</span>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['breakpoints'])
  }
}
</script>

<style lang="scss">
.query-bar {
  @include caption;
  display: grid;
  grid-template-columns: repeat(8, minmax(7.75rem, 1fr));
  grid-gap: measure(quarter);
  padding: measure(half);
  text-align: center;
}

.query-bar > * {
  padding: 2px;
  background-color: #ededed;
}

.query-bar__active {
  @include caption-bold;
}
</style>
